Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _react = require("react");
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _Header = require("../Header");
var useStyles = exports.useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_Header.HeaderContext),
    textColor = _useContext.textColor;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontBold = _STYLES$useStyles.fontBold;
  var valueContainer = Object.assign({
    textAlign: 'center'
  }, _reactNative.Platform.select({
    web: {
      wordBreak: 'break-word'
    }
  }));
  var value = Object.assign({}, fontBold, {
    color: textColor || colors.brand,
    fontSize: _styles.STYLES.fontSize.xl,
    lineHeight: _styles.STYLES.lineHeight.xl
  });
  var unit = Object.assign({}, fontBold, {
    color: textColor || colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.xl
  });
  var styles = _reactNative.StyleSheet.create({
    valueContainer: valueContainer,
    value: value,
    unit: unit
  });
  return {
    styles: styles
  };
};